import type { Translations } from './types';

export const ru: Translations = {
  common: {
    open: 'Открыть',
    close: 'Закрыть',
    cancel: 'Отмена',
    save: 'Сохранить',
    filters: 'Фильтры',
    yes: 'Да',
    no: 'Нет',
    balance: 'Баланс',
    actions: 'Действия',
    id: 'ID',
    name: 'Имя',
    phone: 'Телефон',
    email: 'Email',
    rowNumber: '№',
    city: 'Город',
    role: 'Роль',
    status: 'Статус',
    finance: 'Финансы',
    queue: 'Очередь',
    security: 'Безопасность',
    system: 'Система',
    management: 'Управление',
    noRecords: 'Нет записей',
    noActions: 'Нет действий',
    noOperations: 'Нет операций',
    emptyDash: '—',
    countFiltered: '{{filtered}} из {{total}}',
    featurePending: 'Ручки под это пока нет',
    registeredAt: 'Дата регистрации',
    lastActivity: 'Последняя активность',
    lastLogin: 'Последний вход',
    lastAction: 'Последнее действие',
    createdAt: 'Дата создания',
    today: 'Сегодня, {{time}}',
    yesterday: 'Вчера, {{time}}',
    kpi: 'KPI',
    fullName: 'ФИО',
    qr: 'QR',
    enterPin: 'Ввести PIN',
    pinRequired: 'Введите PIN',
    wrongPin: 'Неверный PIN',
    tooManyAttempts: 'Слишком много попыток. Попробуйте позже.',
    pinDigit: 'Цифра PIN {{index}}',
    backToDashboard: 'Вернуться на панель управления',
    on: 'ВКЛ',
    off: 'ВЫКЛ',
    enabled: 'Включено',
    skip: {
      until: 'Пропускает до {{time}}',
      active: 'Временно пропускает',
      skippingCars: 'Пропускает автомобили',
      usedSkip: 'Использовал пропуск',
      stopSkipping: 'Больше не пропускать',
    },
    disabled: 'Выключено',
    featureComingSoon: '{{action}} — ручки под это пока нет.',
    client: 'Клиент',
    owner: 'Владелец',
  },
  nav: {
    dashboard: 'Панель управления',
    users: 'Пользователи',
    logs: 'Логи',
    staff: 'Персонал',
  },
  sidebar: {
    brandSubtitle: 'Панель администратора',
    mainNavigation: 'Основная навигация',
  },
  topBar: {
    administration: 'Администрирование',
    adminFallback: 'Админ',
    roles: {
      ceo: 'Администратор',
      manager: 'Менеджер',
      support: 'Поддержка',
      operator: 'Оператор',
      owner: 'Владелец',
      'wash-admin': 'Администратор мойки',
      client: 'Клиент',
    },
  },
  auth: {
    accessDenied: {
      title: 'Доступ запрещён',
      subtitle: 'У вас нет доступа к этому разделу Unit 1 Admin Web.',
      backToDashboard: 'Вернуться на панель управления',
    },
    sessionLoading: 'Проверка авторизации…',
    staffIdentityResolving: 'Проверка доступа сотрудника…',
    staffIdentityDenied: 'У аккаунта нет доступа к Unit 1 Admin.',
    signOut: 'Выйти',
    unit1AdminAccessDenied: 'У аккаунта нет доступа Unit 1 Admin',
  },
  login: {
    title: 'Unit 1 Admin',
    subtitlePhone: 'Введите номер телефона — пришлём код',
    subtitleCode: 'Код отправлен на {{phone}}',
    phoneLabel: 'Номер телефона',
    phonePlaceholder: '+7 700 000 00 00',
    codeLabel: 'Код из SMS',
    codePlaceholder: '000000',
    sendCode: 'Получить код',
    sendingCode: 'Отправляем…',
    signIn: 'Войти',
    signingIn: 'Вход…',
    resend: 'Отправить код повторно',
    resendIn: 'Повторить через {{seconds}} с',
    enterExistingCode: 'Ввести код из SMS',
    codeAlreadySent: 'Код уже отправлен на этот номер. Новый можно запросить через {{seconds}} с.',
    changePhone: 'Изменить номер',
    errorInvalidPhone: 'Неверный формат номера. Нужен казахстанский номер: +7 и 10 цифр.',
    errorInvalidCodeFormat: 'Код состоит из 6 цифр.',
    errorCodeInvalid: 'Неверный код.',
    errorAttemptsExceeded: 'Слишком много попыток. Запросите новый код.',
    errorResendTooSoon: 'Код уже отправлен. Подождите перед повторной отправкой.',
    errorAttemptExpired: 'Срок действия кода истёк. Запросите новый.',
    errorUnavailable: 'Сервер авторизации недоступен. Проверьте соединение.',
    errorInternal: 'Не удалось войти. Попробуйте позже.',
  },
  status: {
    filterAll: 'Все',
    filterActive: 'Активные',
    filterInactive: 'Неактивные',
    filterBlocked: 'Заблокированные',
    filterPending: 'Ожидают подключения',
    filterInQueue: 'В очереди',
    filterNoQueue: 'Без очереди',
    userActive: 'Активный',
    userActiveDrawer: 'Активен',
    userBlocked: 'Заблокирован',
    ownerActive: 'Активен',
    ownerPending: 'Ожидает подключения',
    ownerBlocked: 'Заблокирован',
    carWashActive: 'Активна',
    carWashInactive: 'Неактивна',
    carWashPending: 'Ожидает подключения',
    adminActive: 'Активен',
    adminInactive: 'Неактивен',
    staffActive: 'Активен',
    staffBlocked: 'Заблокирован',
    staffPending: 'Ожидает',
    roleCeo: 'CEO',
    roleManager: 'Менеджер',
    roleSupport: 'Поддержка',
    roleOperator: 'Оператор',
    roleOwner: 'Владелец',
    roleWashAdmin: 'Администратор мойки',
  },
  pagination: {
    ariaLabel: 'Постраничная навигация',
    range: 'Показано {{from}}–{{to}} из {{total}}',
    previous: 'Предыдущая страница',
    next: 'Следующая страница',
  },
  users: {
    openUser: 'Открыть карточку: {{name}}',
    mockColumn: 'нет в API',
    mockColumnHint: 'Данных для этой колонки бэкенд пока не отдаёт — показана заглушка.',
    pageTitle: 'Пользователи',
    pageSubtitle: 'Все зарегистрированные пользователи Unit 1.',
    searchPlaceholder: 'Поиск по имени или телефону...',
    countAll: '{{count}} пользователей',
    empty: 'Пользователи не найдены',
    listLoading: 'Загрузка пользователей…',
    listLoadError:
      'Не удалось загрузить пользователей. Проверьте подключение и права доступа.',
    listEmpty: 'Пользователи ещё не зарегистрированы.',
    queue: 'Очередь',
    drawerAriaLabel: 'Пользователь {{name}}',
    happeningNow: 'Сейчас происходит',
    inQueueNow: 'Пользователь сейчас в очереди',
    carWash: 'Автомойка',
    assignedBox: 'Назначенный бокс',
    carsAhead: 'Перед ним автомобилей',
    estimatedWait: 'Примерное ожидание',
    skipActive: 'Пропуск активен',
    skipUntil: 'Пропуск до',
    skipDurationMinutes: 'Длительность пропуска',
    skipUsed: 'Пропуск использован',
    notInQueue: 'Пользователь сейчас не находится в очереди.',
    basicInfo: 'Основная информация',
    operationHistory: 'История операций',
    queueHistory: 'История очередей',
    recentActivity: 'Последние действия пользователя',
    topUp: 'Пополнить',
    topUpTitle: 'Пополнение баланса',
    topUpConfirmTitle: 'Подтверждение пополнения',
    topUpAmountLabel: 'Сумма пополнения, KZT',
    topUpReasonLabel: 'Причина',
    topUpClientIdLabel: 'clientId',
    topUpContinue: 'Продолжить',
    topUpBack: 'Назад',
    topUpSubmit: 'Пополнить',
    topUpSubmitting: 'Пополнение…',
    topUpConfirm:
      'Пополнить баланс {{name}} на {{amount}}?\nПричина: {{reason}}',
    topUpAmountRequired: 'Укажите сумму пополнения.',
    topUpAmountInteger: 'Сумма должна быть целым числом.',
    topUpAmountPositive: 'Сумма должна быть больше 0.',
    topUpAmountCap: 'Сумма не может превышать 50 000 ₸ за одну операцию.',
    topUpReasonRequired: 'Укажите причину пополнения.',
    topUpReasonTooLong: 'Причина слишком длинная.',
    topUpDenied: 'Недостаточно прав для пополнения баланса.',
    topUpUnavailable: 'Пополнение недоступно: нет связи с backend.',
    topUpNotFound: 'Пользователь не найден.',
    topUpInvalid: 'Проверьте сумму и причину пополнения.',
    topUpFailed: 'Не удалось пополнить баланс. Сумма не зачислена.',
    deduct: 'Списать',
    writeOffTitle: 'Аварийное списание',
    writeOffConfirmTitle: 'Подтверждение списания',
    writeOffAmountLabel: 'Сумма списания, KZT',
    writeOffReasonLabel: 'Причина',
    writeOffClientIdLabel: 'clientId',
    writeOffContinue: 'Продолжить',
    writeOffBack: 'Назад',
    writeOffSubmit: 'Списать',
    writeOffSubmitting: 'Списание…',
    writeOffWarning:
      'Это аварийное списание. Средства будут списаны с баланса пользователя без частичного выполнения.',
    writeOffConfirm:
      'Списать {{amount}} с баланса {{name}}?\nПричина: {{reason}}',
    writeOffAmountRequired: 'Укажите сумму списания.',
    writeOffAmountInteger: 'Сумма должна быть целым числом.',
    writeOffAmountPositive: 'Сумма должна быть больше 0.',
    writeOffAmountCap: 'Сумма не может превышать 1 000 000 ₸.',
    writeOffAmountExceedsBalance: 'Сумма не может превышать текущий баланс пользователя.',
    writeOffReasonRequired: 'Укажите причину списания.',
    writeOffReasonTooLong: 'Причина слишком длинная.',
    writeOffDenied: 'Недостаточно прав для списания баланса.',
    writeOffUnavailable: 'Списание недоступно: нет связи с backend.',
    writeOffNotFound: 'Пользователь не найден.',
    writeOffInvalid: 'Проверьте сумму и причину списания.',
    writeOffInsufficient: 'Недостаточно средств на балансе пользователя.',
    writeOffFailed: 'Не удалось списать средства. Баланс не изменён.',
    resetQueue: 'Сбросить очередь',
    deleteUserTitle: 'Удалить пользователя?',
    deleteUserText: 'Учётная запись, история операций и баланс будут удалены без возможности восстановить.',
    deleteUserConfirm: 'Удалить',
    blockUserFailed: 'Не удалось заблокировать пользователя.',
    unblockUserFailed: 'Не удалось разблокировать пользователя.',
    deleteUserSubmitting: 'Удаляем…',
    deleteUserWordLabel: 'Введите слово {{word}}, чтобы подтвердить',
    deleteUserWordMismatch: 'Нужно ввести слово {{word}}.',
    deleteUserSuccess: 'Пользователь удалён.',
    deleteUserFailed: 'Не удалось удалить пользователя.',
    resetQueueConfirm:
      'Удалить этого пользователя из текущей очереди?\nБаланс клиента не изменится.',
    resetQueueSuccess: 'Пользователь удалён из очереди.',
    resetQueueNotInQueue: 'Пользователь не находится в очереди.',
    resetQueueWashing: 'Клиент уже находится в боксе. Используйте завершение мойки.',
    resetQueueDenied: 'Недостаточно прав для сброса очереди.',
    resetQueueUnavailable: 'Сброс очереди недоступен: нет связи с backend.',
    resetQueueFailed: 'Не удалось сбросить очередь. Состояние не изменено.',
    blockUser: 'Заблокировать пользователя',
    unblockUser: 'Разблокировать пользователя',
    deleteUser: 'Удалить пользователя',
  },
  staff: {
    pageTitle: 'Доступ сотрудников',
    pageSubtitle: 'Управление сотрудниками Unit 1 Admin Web',
    searchPlaceholder: 'Поиск по имени, телефону, email, городу...',
    searchAriaLabel: 'Поиск сотрудников',
    countAll: '{{count}} сотрудников',
    addMember: '+ Добавить сотрудника',
    addSearchLabel: 'Найдите пользователя',
    addSearchPlaceholder: 'Имя или телефон',
    addSearchHint: 'Сотрудник — это существующий пользователь, которому выдали роль.',
    addNotFound: 'Никого не нашли',
    addNoCandidates: 'Все пользователи уже в персонале',
    addSelected: 'Выбран',
    addSubmit: 'Выдать роль',
    empty: 'Сотрудники не найдены',
    loading: 'Загрузка сотрудников…',
    editRole: 'Изменить роль',
    unblock: 'Разблокировать',
    deactivate: 'Отключить доступ',
    drawerAriaLabel: 'Сотрудник {{name}}',
    basicInfo: 'Основная информация',
    actionHistory: 'История действий',
    authService: 'Сервис авторизации',
    resetPassword: 'Сбросить пароль',
    resendInvitation: 'Отправить приглашение повторно',
    kpiTotal: 'Всего сотрудников',
    kpiOnline: 'Онлайн сейчас',
    addModalTitle: 'Добавить сотрудника',
    addModalSubtitle:
      'CEO создаётся отдельно и не может быть добавлен через эту форму.',
    editModalTitle: 'Изменить роль',
    editModalSubtitle: '{{name}} — текущая роль: {{role}}',
    newRole: 'Новая роль',
    deactivateTitle: 'Отключить доступ?',
    deactivateText: 'Сотрудник потеряет доступ к Unit 1 Admin Web.',
    auditLogin: 'Вход в систему',
    auditViewDashboard: 'Просмотр Dashboard',
    auditOpenUsers: 'Открыт раздел Users',
    auditCreateOwner: 'Создан владелец',
    auditChangeStaffRole: 'Изменена роль сотрудника',
    auditDeactivateStaff: 'Доступ отключён',
    auditReactivateStaff: 'Доступ восстановлен',
    auditChangeSettings: 'Изменены настройки',
    memberCreated: 'Сотрудник создан.',
    roleChanged: 'Роль изменена на {{role}}.',
    employeeBlocked: 'Сотрудник заблокирован.',
    employeeRestored: 'Доступ сотрудника восстановлен.',
    toastMemberCreated: 'Сотрудник успешно создан.',
    toastRoleUpdated: 'Роль успешно обновлена.',
    toastEmployeeBlocked: 'Сотрудник заблокирован.',
    toastEmployeeRestored: 'Доступ сотрудника восстановлен.',
    toastResetPassword:
      'Сброс пароля появится, когда бэкенд его поддержит.',
    toastResendInvitation:
      'Повторное приглашение появится, когда бэкенд его поддержит.',
    auditMemberCreated: 'Сотрудник создан.',
    auditRoleChanged: 'Роль изменена на {{role}}.',
    auditEmployeeBlocked: 'Сотрудник заблокирован.',
    auditEmployeeRestored: 'Доступ сотрудника восстановлен.',
  },
  profileGate: {
    title: 'Заполните профиль',
    subtitle: 'Укажите имя и фамилию — без них кабинет недоступен.',
    nameLabel: 'Имя',
    namePlaceholder: 'Введите имя',
    surnameLabel: 'Фамилия',
    surnamePlaceholder: 'Введите фамилию',
    submit: 'Обновить',
    saving: 'Сохраняем…',
    errorInvalid: 'Проверьте имя и фамилию.',
    errorUnavailable: 'Сервер недоступен. Попробуйте ещё раз.',
    errorInternal: 'Не удалось сохранить. Попробуйте позже.',
    errorNotSaved: 'Сервер принял запрос, но данные не сохранились. Попробуйте ещё раз.',
  },
  theme: {
    toDark: 'Тёмная тема',
    toLight: 'Светлая тема',
  },
  connection: {
    title: 'Связь с сервером',
    connected: 'Соединение установлено',
    connecting: 'Подключение…',
    disconnected: 'Связи нет',
    updated: 'обновлено {{time}}',
  },
  dashboard: {
    title: 'Панель управления',
    subtitle: 'Операционная картина системы Unit 1',
    live: 'Онлайн',
    updated: 'Обновлено: {{time}}',
    back: '← Панель управления',
    minutes: 'мин',
    minutesShort: '{{count}} мин',
    operational: {
      title: 'Операционная панель',
      subtitle: 'Ежедневная операционная картина системы',
      usersOnline: 'Пользователи онлайн',
      carWashesWithProblems: 'Автомойки с проблемами',
      boxesOffline: 'Боксы отключены',
      averageWait: 'Среднее ожидание',
      noShowToday: 'Не приехали сегодня',
      cancelledToday: 'Отменили сегодня',
      problemCarWashes: 'Проблемные автомойки',
      noProblems: 'Проблемных автомоек нет',
    },
    business: {
      title: 'Бизнес-панель',
      subtitle: 'CEO / инвесторская картина бизнеса Unit 1',
      totalUsers: 'Пользователей всего',
      newUsersThisMonth: 'Новых пользователей за месяц',
      userGrowth: 'Рост пользователей',
      connectedCarWashes: 'Автомоек подключено',
      monthlyRevenue: 'Доход за месяц',
      servedThisMonth: 'Обслужено автомобилей за месяц',
      remoteEntriesThisMonth: 'Дистанционных постановок за месяц',
      qrEntriesThisMonth: 'QR-постановок за месяц',
      revenueChart: 'Динамика дохода (mock)',
      topCarWashes: 'Топ-10 автомоек',
      noData: 'Данные недоступны',
      clientsToday: 'Клиентов сегодня',
      unit1Revenue: 'Доход Unit 1',
    },
    table: {
      carWash: 'Автомойка',
      problem: 'Проблема',
    },
    liveQueue: {
      title: 'Живая очередь',
      subtitle: 'Текущие очереди по сети автомоек',
      totalInQueue: 'Сейчас в очередях',
      averageWait: 'Среднее ожидание',
      activeCarWashes: 'Активных автомоек',
      assignedToBoxes: 'Назначено на боксы',
      wait: 'Ожидание',
      empty: 'Очереди пусты',
    },
    staffOnline: {
      title: 'Поддержка онлайн',
      subtitle: 'Активность сотрудников техподдержки',
      onlineCount: '{{count}} онлайн',
      empty: 'Сотрудники не найдены',
      securityNote:
        'CEO доступ скрыт из онлайн-статусов. Действия CEO будут доступны только в защищённых логах.',
    },
    ceo: {
      title: 'CEO-аналитика',
      description: 'Внутренняя аналитика компании.',
      access: 'Доступ только владельцу Unit 1.',
      subtitle: 'Закрытая аналитика Unit 1',
      overviewTitle: 'Общая статистика Unit 1',
      overviewAria: 'Общая статистика Unit 1',
      totalUsers: 'Всего пользователей',
      activeToday: 'Активных сегодня',
      userGrowth: 'Рост пользователей',
      revenue: 'Доход',
      carWashes: 'Автомоек',
      queues: 'Очередей',
      monthlyRevenue: 'Доход месяца',
      monthlyGrowth: 'Рост месяца',
      newUsers: 'Новые пользователи',
      accessDenied: 'Доступ запрещён.',
      accessDeniedSubtitle: 'Доступ к CEO-аналитике возможен только после ввода PIN.',
      backToDashboard: 'Вернуться на панель управления',
      pinSubtitle: 'Введите PIN для просмотра закрытой информации.',
      pinDigit: 'Цифра PIN {{index}}',
      pinRequired: 'Введите PIN',
      pinInvalid: 'Неверный PIN',
      pinLocked: 'Слишком много попыток. Попробуйте позже.',
    },
    systemHealth: {
      title: 'Состояние системы',
      subtitle: 'Состояние ключевых сервисов Unit 1',
    },
    carWashStatus: {
      active: 'Активна',
      warning: 'Внимание',
      inactive: 'Неактивна',
    },
    onlineStatus: {
      online: 'Онлайн',
      offline: 'Не в сети',
    },
    queueStatus: {
      next: 'Следующий',
      assigned: 'Назначен',
      waiting: 'Ожидает',
    },
    systemHealthStatus: {
      ok: 'работает',
      error: 'недоступен',
      degraded: 'нестабильно',
    },
    staffRole: {
      support: 'Поддержка',
      manager: 'Менеджер',
      operator: 'Оператор',
      ceo: 'CEO',
      owner: 'Владелец',
      client: 'Клиент',
      washAdmin: 'Администратор мойки',
    },
  },
  logs: {
    title: 'Журнал',
    subtitle: 'Журнал действий и безопасности Unit 1.',
    kpiTitle: 'Сводка',
    kpiEventsToday: 'Событий сегодня',
    kpiAccessErrors: 'Ошибок доступа',
    kpiFinanceActions: 'Финансовых действий',
    kpiCarWashChanges: 'Изменений автомоек',
    kpiStaffActions: 'Действий сотрудников',
    kpiCriticalEvents: 'Критических событий',
    pinTitle: 'CEO / Защищённые записи',
    pinSubtitle: 'Введите PIN для просмотра защищённых записей журнала.',
    pinGateText:
      'Фильтр CEO / Защищённые требует подтверждения PIN. Защищённые записи недоступны обычным сотрудникам.',
    protectedTitle: 'CEO / Защищённые записи',
    protectedSubtitle:
      'Записи о финансах, CEO Analytics, PIN и других защищённых действиях.',
    pinRequired: 'Требуется PIN',
    protectedLockedText:
      'Защищённые записи журнала доступны только CEO после подтверждения PIN. Обычные сотрудники не видят эти данные.',
    protectedCount: '{{count}} защищённых записей',
    protectedEmpty: 'Защищённые записи не найдены',
    protectedSectionAria: 'Защищённые записи CEO',
    tableTitle: 'Журнал действий',
    tableEmpty: 'Записи не найдены',
    listLoading: 'Загрузка журнала…',
    listLoadError:
      'Не удалось загрузить журнал. Проверьте подключение и права доступа.',
    listEmpty: 'Журнал действий появится, когда бэкенд начнёт его отдавать.',
    colDate: 'Дата',
    colTime: 'Время',
    colActor: 'Сотрудник',
    colRole: 'Роль',
    colCity: 'Город',
    colSection: 'Раздел',
    colAction: 'Действие',
    colTarget: 'Объект',
    colResult: 'Результат',
    colReason: 'Причина',
    moneyAmount: 'Сумма',
    moneyBalance: 'Баланс',
    colDevice: 'IP / Устройство',
    searchActor: 'Сотрудник',
    searchRole: 'Роль',
    searchAction: 'Действие',
    searchTargetId: 'ID объекта',
    searchPhone: 'Телефон',
    searchCarWash: 'Автомойка',
    placeholderName: 'Имя...',
    placeholderRole: 'CEO, Support...',
    placeholderAction: 'Вход, изменён...',
    placeholderTargetId: 'usr-001, cw-003...',
    placeholderPhone: '+7 ...',
    placeholderCarWash: 'Название...',
    filterLabel: 'Фильтр:',
    filterAll: 'Все',
    filterLogins: 'Входы',
    filterUsers: 'Пользователи',
    filterOwners: 'Владельцы',
    filterCarWashes: 'Автомойки',
    filterFinance: 'Финансы',
    filterQueues: 'Очереди',
    filterSecurity: 'Безопасность',
    filterCeo: 'CEO / Защищённые',
    categoriesAria: 'Категории',
    exportAria: 'Экспорт',
    exportCsv: 'CSV',
    exportExcel: 'Excel',
    exportPdf: 'PDF',
    entriesCount: '{{count}} записей',
    exportAlert: 'Экспорт логов появится вместе с ручкой журнала. ({{count}} записей)',
    result: {
      success: 'Успех',
      warning: 'Предупреждение',
      error: 'Ошибка',
      critical: 'Критично',
      access_denied: 'Доступ запрещён',
      no_op: 'Без изменений',
      failure: 'Ошибка',
    },
    action: {
      emergency_queue_reset: 'Сброс очереди клиента',
      emergency_wallet_topup: 'Аварийное пополнение баланса',
      emergency_wallet_writeoff: 'Аварийное списание баланса',
    },
  },
};
